import Image from 'next/image';
import cn from 'classnames';
import 'balloon-css';

import { resolveAuthorsName } from '@/utils/blog';

interface AuthorProps {
  photo: {
    url: string;
    alt?: string;
  };
  name: string;
}

const photoSize = {
  small: 30,
  large: 36,
};

export default function Authors({
  authors,
  type,
  showAuthorsName = false,
}: {
  authors: AuthorProps[];
  type: 'small' | 'large';
  showAuthorsName?: boolean;
}) {
  const defaultSize =
    type === `small` ? `w-[30px] h-[30px] text-[10px]` : `w-9 h-9 text-sm`;

  return (
    <div className="inline-flex items-center isolate">
      <div className="flex-shrink-0 inline-flex items-center relative -space-x-1 isolate">
        {authors.map((author, index) => {
          if (index > 2) return null;

          const zIndex = authors.length - index;

          return (
            <div
              key={author.name}
              className="inline-flex ring-2 ring-white bg-catskill-white shadow-xl rounded-full relative"
              style={{ zIndex, cursor: `auto` }}
              {...(!showAuthorsName && {
                'aria-label': author?.name,
                'data-balloon-pos': `down`,
              })}
            >
              {author?.photo?.url && (
                <Image
                  className="rounded-full"
                  src={author.photo.url}
                  alt={author.photo?.alt}
                  width={photoSize[type]}
                  height={photoSize[type]}
                  objectFit="cover"
                />
              )}
            </div>
          );
        })}

        {authors.length > 3 && (
          <div
            aria-hidden="true"
            className={cn(
              `inline-flex items-center justify-center ring-2 ring-white bg-catskill-white shadow-xl rounded-full z-[-1]`,
              defaultSize,
            )}
          >
            <span>...</span>
          </div>
        )}
      </div>
      {showAuthorsName && (
        <span className="block ml-2 text-zodiac">
          {resolveAuthorsName(authors)}
        </span>
      )}
    </div>
  );
}
